import AudienceApi from '@/api/audience'
import AccountApi from '@/api/account'
import PresentationApi from '@/api/presentation'
import UserApi from '@/api/user'
import FolderApi from '@/api/folder'
import SlideApi from '@/api/slide'
import SlideAnnotationsApi from '@/api/slideAnnotations'
import StripeApi from '@/api/stripe'
import PricingApi from '@/api/pricing'
import AnswerApi from '@/api/answer'
import SlideOptionApi from '@/api/slideOption'
import StickerApi from '@/api/sticker'
import AuthApi from '@/api/auth'
import InvitationApi from '@/api/invitation'
import InvoiceApi from '@/api/invoice'
import ChatApi from '@/api/chat'
import templateApi from '@/api/template'
import searchApi from '@/api/search'
import promoApi from '@/api/promo'
import planApi from '@/api/plan'
import communityApi from '@/api/community'
import categoryApi from '@/api/category'
import opentokApi from '@/api/opentok'
import audienceAuthenticationApi from '@/api/audienceAuthentication'
import collabApi from '@/api/collab'
import openaiApi from '@/api/openai'
import hintApi from '@/api/hint'
import commentApi from '@/api/comment'
import notificationApi from '@/api/notification'
import AIResponseAPI from '@/api/aiResponse'
import ABTestAPI from '@/api/abTest'
import SurveyAPI from '@/api/survey'
import YoutubeAPI from '@/api/youtube'
import PresentationSessionApi from '@/api/presentationSession'
import UploadApi from '@/api/upload'
import PlanBenefitApi from '@/api/planBenefit'
import UserAdsCampaign from '@/api/userAdsCampaign'
import MyPhotoAPI from '@/api/myPhoto'
import OnboardingFeatureBasedOptionsAPI from '@/api/onboardingFeatureBasedOptions'
import TenorAPI from '@/api/tenor'
import LiveStatsApi from '@/api/live-stats'
import ConnectorApi from '@/api/connector'
import ConnectorApiV2 from '@/api/connector.v2'
import GoogleSlideApi from '@/api/googleSlide'
import KeywordApi from '@/api/keyword'
import zohoSSO from '@/api/zohoSSO'
import presetApi from '@/api/preset'
import presentationAttributeApi from '@/api/presentationAttribute'
import questionSuggestion from '@/api/question-recommendations'
import kvSyncApi from '@/api/kvSync'
import themeApi from '@/api/theme'
import LeaderboardApi from '@/api/leaderboard'
import EmbedSlideApi from '@/api/embed-slide'
import MultipleSessionApi from '@/api/multipleSession'

const initResources = () => {
  AccountApi.initResource()
  PresentationApi.initResource()
  UserApi.initResource()
  FolderApi.initResource()
  SlideApi.initResource()
  SlideAnnotationsApi.initResource()
  StripeApi.initResource()
  PricingApi.initResource()
  AnswerApi.initResource()
  SlideOptionApi.initResource()
  StickerApi.initResource()
  AuthApi.initResource()
  InvitationApi.initResource()
  InvoiceApi.initResource()
  ChatApi.initResource()
  templateApi.initResource()
  searchApi.initResource()
  promoApi.initResource()
  planApi.initResource()
  communityApi.initResource()
  categoryApi.initResource()
  opentokApi.initResource()
  audienceAuthenticationApi.initResource()
  collabApi.initResource()
  openaiApi.initResource()
  hintApi.initResource()
  commentApi.initResource()
  notificationApi.initResource()
  AIResponseAPI.initResource()
  ABTestAPI.initResource()
  SurveyAPI.initResource()
  YoutubeAPI.initResource()
  PresentationSessionApi.initResource()
  UploadApi.initResource()
  PlanBenefitApi.initResource()
  UserAdsCampaign.initResource()
  MyPhotoAPI.initResource()
  OnboardingFeatureBasedOptionsAPI.initResource()
  TenorAPI.initResource()
  ConnectorApi.initResource()
  ConnectorApiV2.initResource()
  LiveStatsApi.initResource()
  GoogleSlideApi.initResource()
  KeywordApi.initResource()
  zohoSSO.initResource()
  AudienceApi.initResource()
  presetApi.initResource()
  presentationAttributeApi.initResource()
  questionSuggestion.initResource()
  kvSyncApi.initResource()
  themeApi.initResource()
  LeaderboardApi.initResource()
  EmbedSlideApi.initResource()
  MultipleSessionApi.initResource()
}

export default {
  initResources,
}
